import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import AnnouncementPopup from "../components/announcementPopup/AnnouncementPopup";
import HomepageComponentsFromJson from "../components/newHomePage/HomepageComponentsFromJson";
import HomepageContainer from "../components/newHomePage/HomepageContainer/HomepageContainer";
import HomepageHeaderContainer from "../components/newHomePage/HomepageHeaderContainer/HomepageHeaderContainer";
import HomepageHeaderGreeting from "../components/newHomePage/HomepageHeaderGreeting/HomepageHeaderGreeting";
import { Content, HomeScreen } from "../components/newHomePage/utils/homepageJson.types";
import RecipeCreationPopup from "../components/recipeCreation/RecipeCreationPopup";
import VersionChecker from "../components/versionChecker/VersionChecker";
import useLogRecipeEdit from "../hooks/useLogRecipeEdit";
import useScrollPositionRestoration from "../hooks/useScrollPositionRestoration";
import { EventLogsEnum } from "../utils/events";
import { AddIcon } from "../utils/iconRefs/homePageIcons";
import styles from "./mainpage.module.css";

const MainPage = ({ homeConfig }: { homeConfig: HomeScreen }) => {
  const { logRecipeEdit } = useLogRecipeEdit();
  const [showRecipeCreationPopup, setShowRecipeCreationPopup] = useState<boolean>(false);

  useScrollPositionRestoration("scrollheightHomePage", []);

  const handleClickOpen = () => {
    setShowRecipeCreationPopup(true);
  };

  useEffect(() => {
    logRecipeEdit(EventLogsEnum.APP_HOMEPAGE_INITIALIZED);
  }, [])

  return (
    <>
      <VersionChecker />
      <AnnouncementPopup />
      <HomepageContainer>
        <HomepageHeaderContainer>
          <HomepageHeaderGreeting />
          <Button className={styles.create_button_home} id="create-recipe-button" onClick={handleClickOpen}>
            <Typography variant='caption3Light'>Create</Typography>
            <AddIcon />
          </Button>
        </HomepageHeaderContainer>
        <RecipeCreationPopup open={showRecipeCreationPopup} setOpen={setShowRecipeCreationPopup} />
        <Grid className={styles.content_wrapper} id="components_from_json">
          {homeConfig?.contents.map((data: Content) => (
            <HomepageComponentsFromJson
              data={data}
              homePageRow={data.homePageRow}
              key={data.id}
              viewedHomePageRow={data.viewedHomePageRow}
            />
          ))}
        </Grid>
      </HomepageContainer>
    </>
  );
};

export default MainPage;
